import { UtilisateurTypeCode } from './enums/type-utilisateur.enum';
export class UtilisateurType {
    static jsonMap = {
        id: 'id',
        code: { key: 'code', optional: true },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    public id: number;
    public code: UtilisateurTypeCode;
    public libelle: string;
}
